import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AdminLayout } from './AdminLayout';

const AdminPortal: React.FC = () => {
  const location = useLocation();

  // Map routes to page titles for AdminLayout
  const getPageTitle = (pathname: string): string => {
    // Remove '/admin' prefix and handle nested paths
    const adminPath = pathname.replace('/admin', '') || '/';

    const titleMap: Record<string, string> = {
      '/': 'Dashboard',
      '/pending-users': 'Pending Registrations',
      '/users': 'User Management',
      '/members': 'Member Management',
      '/announcements': 'Announcements',
      '/events': 'Event Management',
      '/communications': 'Communications Dashboard',
      '/communications/compose': 'Compose Email',
      '/communications/templates': 'Email Templates',
      '/communications/analytics': 'Analytics Dashboard',
      '/payments': 'Payment Dashboard',
      '/payments/donations': 'Donation Management',
      '/payments/reports': 'Financial Summary',
      '/expenses': 'Expenses',
      '/dues': 'Dues Management',
      '/documents': 'Document Management',
      '/audit-log': 'Member Edit Audit Log',
      '/tree-admins': 'Family Tree Admins',
      '/ticketing': 'Items & Sales',
      '/ticketing/check-in': 'Event Check-In',
    };

    // Check exact match first, then pattern match for dynamic routes
    if (titleMap[adminPath]) return titleMap[adminPath];
    if (/^\/events\/[^/]+\/edit$/.test(adminPath)) return 'Event Management';
    return 'Admin';
  };

  const pageTitle = getPageTitle(location.pathname);

  return (
    <AdminLayout title={pageTitle}>
      <Outlet />
    </AdminLayout>
  );
};

export { AdminPortal };